import React from 'react'
 
import IdleTimer from 'react-idle-timer';
import { MessageAPI, PageMessage } from './PageMessage.jsx';

export default class TimeOut extends React.Component {
  constructor (props) {
    super(props)
    this.idleTimer = null
    this.state = {
      timeout: window.env.timeOutWarning * 60 * 1000,
      remaining: null,
      isIdle: false,
      lastActive: null,
      elapsed: null
    }
    // Bind event handlers and methods
    this.onActive = this._onActive.bind(this)
    this.onIdle = this._onIdle.bind(this)
    this.reset = this._reset.bind(this)
    this.pause = this._pause.bind(this)
    this.resume = this._resume.bind(this)
    this.changeTimeout = this._changeTimeout.bind(this)
    this.closePopup = this.closePopup.bind(this)
    this.handleDeleteUserAction = this.handleDeleteUserAction.bind(this)
  }

  handleDeleteUserAction () {
  }

  componentDidMount () {
    if (this.idleTimer) {
      this.setState({
        remaining: this.idleTimer.getRemainingTime(),
        lastActive: this.idleTimer.getLastActiveTime(),
        elapsed: this.idleTimer.getElapsedTime()
      })
    }

    this.intervalId = setInterval(() => {
      if (this.idleTimer) {
        this.setState({
          remaining: this.idleTimer.getRemainingTime(),
          lastActive: this.idleTimer.getLastActiveTime(),
          elapsed: this.idleTimer.getElapsedTime()
        })
      }
    }, 1000)
  }

  componentWillUnmount () {
    if (this.intervalId) {
      clearInterval(this.intervalId)
    }
  }

  render () {
    const events = ['click','keypress'];
    return (
      <div>
        <IdleTimer
          ref={ref => { this.idleTimer = ref }}
          onActive={this.onActive}
          onIdle={this.onIdle}
          timeout={this.state.timeout}
          events={events}
          startOnLoad />
          <PageMessage message={this.state.appMessage} redirectToLogin={this.props.redirectToLogin} closePopup={this.closePopup}/>
      </div>
    )
  }

  closePopup () {
    this.setState({ 
      appMessage: 
        { 
          displayType: ''
        } 
      }
    );
  }

  _onActive () {
    this.setState({ isIdle: false })
  }

  _onIdle () {
    this.setState({
      isIdle: true,
      show: true,
      appMessage: {
        displayType: 'timeoutpopup',
        popupAction: ['Login'],
        popupActionHandler: this.handleDeleteUserAction,
        messageType: 'warning',
        messageInfo: {
          popuptitle: 'Logout Warning',
          message: 'For security reasons, you will be automatically logged out in',
          messageCode: 'RELOGIN_CONFIRMATION'
        }
      }
    })
  }

  _changeTimeout () {
    this.setState({
      timeout: this.refs.timeoutInput.state.value()
    })
  }

  _reset () {
    this.idleTimer.reset()
  }

  _pause () {
    this.idleTimer.pause()
  }

  _resume () {
    this.idleTimer.resume()
  }
}